import React, { Component } from 'react';
import { Card, CardBody, Col, Badge } from 'reactstrap';
// import EyeIcon from 'mdi-react/EyeIcon';
import { reduxForm } from 'redux-form';
import BlogMember from './BlogMember';
import { teamMemberDelete, teamMemberAdd } from '../../../redux/actions/blogsActions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import withErrorNotification from '../../../hof/withErrorNotification';
import { Team } from '../../../services/Team';
import Notifications from '../../../hof/notifications';
import { Button, InputGroup, InputGroupAddon, Input } from 'reactstrap';
import {withTranslation} from "react-i18next";
class BlogTeam extends Component {

  state = {
    new_collaborator: ''
  };

  handleRemoveMember = async (blogId, username) => {
    console.log(blogId, username);
    await withErrorNotification(async () => {
      await Team.removeMember(blogId, username);
      this.props.onTeamMemberRemove(username);
      // TODO move to language files
      Notifications.showNotification("Success", "Collaborator removed", "success");
    })
  }

  handleAddMember = async (blogId, username) => {
    console.log(blogId, username);
    await withErrorNotification(async () => {
      await Team.addMember(blogId, username, 'admin');
      this.props.onTeamAddMember(username, 'admin');
      Notifications.showNotification("Success", "Collaborator added", "success");
      this.setState({ new_collaborator: '' });
    })
  }

  handleClick = (e) => {
    e.preventDefault();
    this.handleAddMember(this.props.blog._id, this.state.new_collaborator)
  }

  render() {

    const {t} = this.props;

    return (<Col md={12} lg={12} xl={12}>
      <Card className="card--not-full-height">
        <CardBody>
          <div className="card__title">
            <h5 className="bold-text">{t('settings.blog_team.title')}
              <Badge className="panel__label">Beta</Badge>
            </h5>
          </div>
          {this.props.owner && <BlogMember img={`https://images.hive.blog/u/${this.props.owner}/avatar`} name={this.props.owner} roles="Owner" />}
          {this.props.collaborators.map(member => <BlogMember
            key={member.username}
            you={this.props.you}
            img={`https://images.hive.blog/u/${member.username}/avatar`}
            name={member.username}
            roles={member.role.charAt(0).toUpperCase() + member.role.slice(1)}
            onRemove={() => { this.handleRemoveMember(this.props.blog._id, member.username) }}
          />)}
          <form className="form form--vertical" onSubmit={this.handleClick}>
            <InputGroup className="form__form-group-field">
              <Input
                placeholder={t('settings.blog_team.placeholder')}
                type="text"
                name="category"
                className="blog-team-input"
                value={this.state.new_collaborator}
                onChange={(event) => { this.setState({ new_collaborator: event.target.value }) }}
              />
              <InputGroupAddon addonType="append">
                <Button
                  className={`form__form-group-button`}
                  color="success"
                  size="sm"
                  onClick={() => this.handleAddMember(this.props.blog._id, this.state.new_collaborator)}
                >{t('settings.blog_team.button_add')}</Button>
              </InputGroupAddon>
            </InputGroup>
          </form>

        </CardBody>
      </Card>
    </Col>)
  }

}

const mapStateToProps = (state) => {
  return {
    blog: state.blogs.blog
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onTeamMemberRemove: (username) => { dispatch(teamMemberDelete(username)) },
    onTeamAddMember: (username, role) => { dispatch(teamMemberAdd(username, role)) }
  }
}

BlogTeam = withRouter(connect(mapStateToProps, mapDispatchToProps)(BlogTeam));

export default reduxForm({
  form: 'blog_team_form'
})(withTranslation('dashboard')(BlogTeam));
